document.addEventListener("DOMContentLoaded", () => {
  const currentUrl = window.location.host
  const shopIsoCode = document.getElementById("ShopifyCountry_IsoCode")?.textContent || ""

  const checkExist = setInterval(() => {
    const swatchKing = document.querySelector("variant-swatch-king")

    if (swatchKing) {
      clearInterval(checkExist)
      setTimeout(() => {
        autoSelectSizeTab(currentUrl, shopIsoCode)
        if (currentUrl.includes("eu.etnies.com")) translateSizes("EU")
        addProductDetails()
        swatchKing.classList.add("variantsShowed")
      }, 400)
    }

    setTimeout(() => swatchKing?.classList.add("variantsShowed"), 1000)
  }, 200)

  document.querySelector('[name="id"]')?.addEventListener("change", updateVariantDetails)

  if (
    document.querySelector(".cart__items") &&
    (currentUrl.includes("eu.etnies.com") || shopIsoCode === "gb")
  ) {
    updateCartSizes()
  }
})

const usWomenProductIds = [10356861534539, 8698127745355, 14640838312304, 9110885007519]

const sizeConversionTable = [
  { US: "2", US_Women: "3.5", EU: "33.5", UK: "1", Mondo: "20" },
  { US: "2.5", US_Women: "4", EU: "34", UK: "1.5", Mondo: "20.5" },
  { US: "3", US_Women: "4.5", EU: "34.5", UK: "2", Mondo: "21" },
  { US: "3.5", US_Women: "5", EU: "35", UK: "2.5", Mondo: "21.5" },
  { US: "4", US_Women: "5.5", EU: "35.5", UK: "3", Mondo: "22" },
  { US: "4.5", US_Women: "6", EU: "36", UK: "3.5", Mondo: "22.5" },
  { US: "5", US_Women: "6.5", EU: "37", UK: "4", Mondo: "23" },
  { US: "5.5", US_Women: "7", EU: "37.5", UK: "4.5", Mondo: "23.5" },
  { US: "6", US_Women: "7.5", EU: "38", UK: "5", Mondo: "24" },
  { US: "6.5", US_Women: "8", EU: "38.5", UK: "5.5", Mondo: "24.5" },
  { US: "7", US_Women: "8.5", EU: "39", UK: "6", Mondo: "25" },
  { US: "7.5", US_Women: "9", EU: "40", UK: "6.5", Mondo: "25.5" },
  { US: "8", US_Women: "9.5", EU: "41", UK: "7", Mondo: "26" },
  { US: "8.5", US_Women: "10", EU: "41.5", UK: "7.5", Mondo: "26.5" },
  { US: "9", US_Women: "10.5", EU: "42", UK: "8", Mondo: "27" },
  { US: "9.5", US_Women: "11", EU: "42.5", UK: "8.5", Mondo: "27.5" },
  { US: "10", US_Women: "11.5", EU: "43", UK: "9", Mondo: "28" },
  { US: "10.5", US_Women: "12", EU: "44", UK: "9.5", Mondo: "28.5" },
  { US: "11", US_Women: "12.5", EU: "45", UK: "10", Mondo: "29" },
  { US: "11.5", US_Women: "13", EU: "45.5", UK: "10.5", Mondo: "29.5" },
  { US: "12", US_Women: "13.5", EU: "46", UK: "11", Mondo: "30" },
  { US: "13", US_Women: "14.5", EU: "47", UK: "12", Mondo: "31" },
  { US: "14", US_Women: "15.5", EU: "48", UK: "13", Mondo: "32" },
  { US: "15", US_Women: "16.5", EU: "49", UK: "14", Mondo: "33" },
]

function autoSelectSizeTab(currentUrl, shopIsoCode) {
  const sizeTabs = document.querySelectorAll(".size-tab")
  let defaultTab = "US Men"
  if (usWomenProductIds.includes(window.meta.product.id)) defaultTab = "US Women"
  if (currentUrl.includes("eu.etnies.com") || shopIsoCode === "ch") defaultTab = "EU"
  if (shopIsoCode === "gb") defaultTab = "UK"
  if (shopIsoCode === "jp") defaultTab = "Mondo"

  sizeTabs.forEach(tab => {
    const tabName = tab.textContent.trim()
    const region = tabName.replace("US Men", "US").replace("US Women", "US_Women")
    tab.classList.toggle("active", tabName === defaultTab)
    if (tabName === defaultTab) translateSizes(region)
  })
}

function addProductDetails() {
  const paragraph = document.createElement("p")
  paragraph.classList.add("currentColor")
  const colorSwatch = document.querySelector("ul.swatch-view-image")
  colorSwatch?.parentNode.insertBefore(paragraph, colorSwatch)
}

function updateVariantDetails(e) {
  const variantId = e.target.value
  const variant = window.meta.product.variants.find(v => v.id == variantId)
  if (variant?.sku) {
    const skuDisplay = document.querySelector(".currentSKU span")
    if (skuDisplay) skuDisplay.textContent = variant.sku
  }
}

function translateSizes(region) {
  const isException = usWomenProductIds.includes(window.meta.product.id)

  document.querySelectorAll("li.swatch-view-item span[swatch-inside='true']").forEach(el => {
    if (!el.hasAttribute("data-original-size")) {
      el.setAttribute("data-original-size", el.textContent.trim())
    }

    const originalSize = el.getAttribute("data-original-size")
    const row = sizeConversionTable.find(
      entry => entry[isException ? "US_Women" : "US"] === originalSize
    )
    if (row?.[region]) el.textContent = row[region]
  })

  const addToCart = document.querySelector('form[action="/cart/add"] button[name="add"]')
  if (addToCart && !addToCart.hasAttribute("data-listener-added")) {
    addToCart.setAttribute("data-listener-added", "true")
    addToCart.addEventListener("click", observeCartNotification)
  }
}

function observeCartNotification() {
  const cartNotif = document.getElementById("cart-notification")
  if (!cartNotif) return

  let debounce
  const observer = new MutationObserver(() => {
    clearTimeout(debounce)
    debounce = setTimeout(updateCartNotificationSizes, 100)
  })

  observer.observe(cartNotif, { childList: true, subtree: true })
}

function updateCartNotificationSizes() {
  const selected = document.querySelector(
    '#swatch-option2 li[aria-checked="true"] .swatch-title-and-icon-container span[swatch-inside="true"]'
  )
  if (!selected) return

  const selectedSize = selected.textContent.trim()
  const cartProduct = document.getElementById("cart-notification-product")

  cartProduct?.querySelectorAll(".product-option").forEach(option => {
    const label = option.querySelector("dt")
    const value = option.querySelector("dd")
    if (label?.textContent.trim() === "Size:" && value) value.textContent = selectedSize
  })
}

function updateCartSizes() {
  const iso = document.getElementById("ShopifyCountry_IsoCode")?.textContent || ""
  const url = window.location.host
  const region = iso === "gb" ? "UK" : url.includes("eu.etnies.com") || iso === "ch" ? "EU" : "EU"

  const usMenMap = Object.fromEntries(sizeConversionTable.map(entry => [entry.US, entry[region]]))
  const usWomenMap = Object.fromEntries(
    sizeConversionTable.map(entry => [entry.US_Women, entry[region]])
  )

  document.querySelectorAll(".cart-item__details dl div.product-option.Size").forEach(option => {
    const label = option.querySelector("dt")
    const value = option.querySelector("dd")
    const productID = Number(option.getAttribute("data-product-id"))

    if (label?.textContent.trim() === "Size:" && value) {
      const currentSize = value.textContent.trim()

      const isUsWomenProduct = usWomenProductIds.includes(productID)
      const translatedSize = isUsWomenProduct ? usWomenMap[currentSize] : usMenMap[currentSize]

      if (translatedSize) {
        value.textContent = translatedSize
      }
    }
  })
}
